import { get } from 'lodash/fp';
import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

export const useWebpageValidator = (isEditable: boolean) => useValidator(validator(isEditable));

const webPageBlockValidator = validators.forEach(
    'webPageBlock',
    validators.compose(
        // columnBlockInput
        validators.only(
            (values, error, { prefix }) => get(prefix, values),
            validators.forEach(
                'columns',
                validators.only((values, error, { prefix: subPrefix }) => {
                    const { title, description } = get(subPrefix, values);

                    return !!title || !!description;
                }, validators.requiredString('description.defaultValue'))
            )
        ),

        // customBlockInput
        validators.only(
            (values, error, { prefix }) => get(prefix, values),
            validators.only((values, error, { prefix }) => {
                const block = get(prefix, values);
                const { title, markDownString } = block;

                return !!title || !!markDownString;
            }, validators.requiredString('markDownString.defaultValue'))
        ),

        // imageBlockInput
        validators.only(
            (values, error, { prefix }) => get(prefix, values),
            validators.forEach(
                'descriptions',
                validators.only((values, error, { prefix: subPrefix }) => {
                    const { title, description } = get(subPrefix, values);

                    return !!title || !!description;
                }, validators.requiredString('title.defaultValue'))
            )
        ),

        // textImageBlockInput
        validators.only(
            (values, error, { prefix }) => get(prefix, values),
            validators.only((values, error, { prefix }) => {
                const block = get(prefix, values);

                const { title, description } = block;

                return !!title || !!description;
            }, validators.requiredString('description.defaultValue'))
        )
    )
);

/**
 * TO CONFIRM
 * :: do we need to check fields in the webpageBlock fields when all inputs are empty
 */
const validator = (isEditable: boolean) =>
    validators.compose(
        validators.only(() => !isEditable, validators.requiredObjectId('moduleId')),
        validators.requiredBoolean('isActive'),
        validators.requiredString('pageTitle.defaultValue'),
        validators.urlSlugChecker('urlSlug')
    );

export default useWebpageValidator;
